// extracted by mini-css-extract-plugin
export default {"productDisclaimer":"ProductDisclaimer_productDisclaimer__U1MUw"};